<template>
  <div class="mr-0 bg-gray-200 maincomponent-area">
    <div class="px-5 py-3">
      <router-link to="/apiresources" class="text-sm text-gray-700 hove:text-gray-900">
        Hem / Apiresurser
      </router-link>
      <h1 class="mt-3 font-sans text-xl leading-none font-medium text-gray-900 whitespace-no-wrap">
        {{ current.name }}
      </h1>
    </div>
    <div class="mx-auto">
      <div class="flex items-justify bg-white">
        <tabs class="relative w-full" v-if="current.id !== undefined">
          <tab name="allmänt" :selected="true">
            <apigeneral />
          </tab>
          <tab name="scope" :selected="false">
            <apiscopes />
          </tab>
          <tab name="egenskaper" :selected="false">
            <apiclaims />
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Tabs from "@/components/Tabs";
import Tab from "@/components/Tab";
import ApiGeneral from "./ApiGeneral";
import ApiScopes from "./ApiScopes";
import ApiClaims from "./ApiClaims";

export default {
  name: "apidetails",
  components: {
    apigeneral: ApiGeneral,
    apiscopes: ApiScopes,
    apiclaims: ApiClaims,
    tabs: Tabs,
    tab: Tab
  },
  computed: {
    ...mapGetters("apiresourcesStore", ["current"])
  },
  methods: {
    ...mapActions("apiresourcesStore", ["fetch"])
  },

  async mounted() {
    await this.fetch(this.$route.params.id);
  }
};
</script>
